export interface FieldFilter {
  operator: FILTER;
  value: string;
  type: 'text' | 'number';
  sourceField: string;
  label?: string
}

export enum FILTER {
  EQUALS = 'eq',
  NOT_EQUALS = 'neq',
  LESS_THAN = 'lt',
  LESS_THAN_OR_EQUAL = 'lte',
  GREATER_THAN = 'gt',
  GREATER_THAN_OR_EQUAL = 'gte',
  IS_NULL = 'isNull',
  IS_NOT_NULL = 'isNotNull',
  LIKE = 'like',
  NOT_LIKE = 'nlike',
  IN = 'in',
  NOT_IN = 'nin',
  START = 'start',
  END = 'end'
}

type TextOperator = {
  label: string
  value: FILTER
}

export const textOperators: TextOperator[] = [
  { label: 'Contains', value: FILTER.LIKE },
  { label: 'Does not contain', value: FILTER.NOT_LIKE },
  { label: 'Starts with', value: FILTER.START },
  { label: 'Ends with', value: FILTER.END },
  { label: 'Equals', value: FILTER.EQUALS },
  { label: 'Does not equal', value: FILTER.NOT_EQUALS },
  { label: 'Is empty', value: FILTER.IS_NULL },
  { label: 'Is not empty', value: FILTER.IS_NOT_NULL },
]

export const numberOperators = [
  { label: 'Greater than', value: FILTER.GREATER_THAN },
  { label: 'Greater than or equal to', value: FILTER.GREATER_THAN_OR_EQUAL },
  { label: 'Less than', value: FILTER.LESS_THAN },
  { label: 'Less than or equal to', value: FILTER.LESS_THAN_OR_EQUAL },
  { label: 'Equals', value: FILTER.EQUALS },
  { label: 'Does not equal', value: FILTER.NOT_EQUALS },
  { label: 'Is empty', value: FILTER.IS_NULL },
  { label: 'Is not empty', value: FILTER.IS_NOT_NULL },
]

export const getOperatorLabel = (operatorValue: string) => {
  const operatorLabel = [...numberOperators, ...textOperators].find(op => op.value === operatorValue)?.label?.toLowerCase()
  return operatorLabel
}
